// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"95d7f5fb","183":"de3e520f","186":"de07b082","201":"de07b082","673":"34090fc8","782":"de3e520f","796":"de07b082","921":"de07b082","940":"de07b082"}[chunkId] + ".css";
};